import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpService } from '../shared/services/http.service';
import { HttpClientModule } from '@angular/common/http';
import { DesiredCreditLimitComponent } from './components/desired-credit-limit/desired-credit-limit.component';
import { CardInfoComponent } from './components/card-info/card-info.component';
import { CardRecommendationComponent } from './components/card-recommendation/card-recommendation.component';
import { RecommendationComponent } from './components/recommendation/recommendation.component';
import { TranslatingDataService } from '../shared/services/translation/translating-data.service';
import { SharingDataService } from 'src/shared/services/sharingData/sharing-data.service';

export function init(
  translatingDataService: TranslatingDataService,
  sharingDataService: SharingDataService
) {
  return () =>
    translatingDataService.retrieveTranslatedData().then(() => {
      sharingDataService.minimumPaymtCalSharedData.TranslatedData = translatingDataService.getTranlateddata();
    });
}

@NgModule({
  declarations: [
    AppComponent,
    DesiredCreditLimitComponent,
    CardInfoComponent,
    RecommendationComponent,
    CardRecommendationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [
    HttpService,
    {
      provide: APP_INITIALIZER,
      useFactory: init,
      deps: [TranslatingDataService, SharingDataService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
